import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'
import { COLOR_ERROR, COLOR_MUTED } from '../../lib/colors'

const UIInputError = ({ errorMessage, dynamicStyle }) => {
  return (
    <span
      className={css(
        styles.message,
        styles.errorMessage,
        dynamicStyle && dynamicStyle
      )}
    >
      {errorMessage}
    </span>
  )
}

const styles = StyleSheet.create({
  message: {
    fontWeight: 400,
    fontSize: 11,
    color: COLOR_MUTED,
  },
  errorMessage: {
    color: COLOR_ERROR,
  },
})

UIInputError.propTypes = {
  errorMessage: PropTypes.string,
  dynamicStyle: PropTypes.node,
}

export default UIInputError
